import { Box, Grid } from '@mui/material'
import React, { Component } from 'react'
import { appContext } from '../../../../AppContext';
import IbssTextField from '../../../../Components/Inputs/TextField/IbssTextField';
import { IbssLuxonDateTimePicker } from '../../../../Components/Inputs/LuxonDateTimePicker/IbssLuxonDateTimePicker';
import { IbssPage } from '../../../../Components/Core/BasePage/IbssPage';
import { DateTime } from 'luxon';

export default class AssociatedDetails extends IbssPage<IProps, IState>
{
    private get labels() { return appContext().labels; }

    render() 
    {
        const { arrivalLocation, arrivalLocationId, bookingName, bookingId, bookingStart, bookingEnd } = this.props;
        return (
            <Box className="tablePanel">
                <h3>{this.labels.HubLabelAssociatedDetails}</h3>
                <IbssTextField
                    fullWidth
                    required
                    disabled
                    label={this.labels.HubLabelArrivalLocation}
                    value={arrivalLocation}
                    variant="outlined"
                    className='mt-3'
                />
                <IbssTextField
                    fullWidth
                    required
                    disabled
                    label={this.labels.HubLabelArrivalLocationId}
                    value={arrivalLocationId}
                    variant="outlined"
                    className='mt-3'
                />
                <IbssTextField
                    fullWidth
                    required
                    disabled
                    label={this.labels.HubLabelBookingName}
                    value={bookingName}
                    variant="outlined"
                    className='mt-3'
                />
                <IbssTextField
                    fullWidth
                    required
                    disabled
                    label={this.labels.HublabelBookingId}
                    value={bookingId}
                    variant="outlined"
                    className='mt-3'
                />
                <Box display={'flex'} sx={{'& > :not(style)': { my: 2,mr:1,},}}>
                    <IbssLuxonDateTimePicker
                        disabled
                        onChange={() => {}}
                        label={this.labels.HubLabelBookingStart}
                        value={bookingStart}
                    />
                    <IbssLuxonDateTimePicker
                        disabled
                        onChange={() => {}}
                        label={this.labels.HubLabelBookingEnd}
                        value={bookingEnd}
                    />
                </Box>
            </Box>
        )
    }
}

export interface IProps
{
    arrivalLocation: string;
    arrivalLocationId: string;
    bookingName: string;
    bookingId: string;
    bookingStart: DateTime;
    bookingEnd: DateTime;
}

export interface IState {}
